import { Component, Input } from '@angular/core';

import { INote } from '@misc/sidebar-notes/notes.service';

import { DPE_DISMISSAL_REASONS } from '@misc/event-dismissal-modal/event-dismissal-modal.consts';

@Component({
  selector: 'dismissal-note',
  templateUrl: './dismissal-note.component.html',
})
export class DismissalNoteComponent {
  @Input() public note: Partial<INote>;
  @Input() public dismissalType: string = $localize`Event`;

  public readonly DPE_DISMISSAL_REASONS: typeof DPE_DISMISSAL_REASONS = DPE_DISMISSAL_REASONS;
}
